const AccessContext = require('./contexts/access-context');

const Flow = require('../entities/flows/flow');

class OfferFlowsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  , offerId
  /*: string*/
  ) {
    this.client = client;
    this.context = context;
    this.offerId = offerId;
  }

  create(newFlow
  /*: Flow*/
  )
  /*: Promise<Object>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const {
      offerId
    } = this;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/flows`;
    const params = {
      template: newFlow.template,
      vars: newFlow.vars
    };
    const req = new this.client.Request(path, params);
    req.serialize = Flow.serialize;
    req.parse = Flow.fromJson;
    return this.client.post(req);
  }

  details(flowId
  /*: string*/
  )
  /*: Promise<Flow>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const {
      offerId
    } = this;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/flows/${flowId}`;
    const req = new this.client.Request(path);
    req.parse = Flow.fromJson;
    return this.client.get(req);
  }

}

module.exports = OfferFlowsRepo;